import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Venta } from "@/shared/types/venta";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface VentasQuery extends BaseQuery {
    desde?: string,
    hasta?: string,
    clienteId?:string,
    vendedorId?: string,
    articuloId?: string,
    numeroVenta?:number,
    numComprobante?: string
}

export async function getAllVentas(query?: VentasQuery): Promise<QueryResponse<Venta>> {
    await sleep(1000);
    const response = await api.get("ventas", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllVentasQuery(query: VentasQuery = {}, queryConfig: QueryConfig<QueryResponse<Venta>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllVentas(query),
        queryKey: ["ventas", query],
    })
}

export interface GetAllVentaQueryProps {
    query: VentasQuery,
    queryConfig?: QueryConfig<QueryResponse<Venta>>,
    children: (queryResult: QueryResult<QueryResponse<Venta>>) => ReactNode
}

export function GetAllVentasQuery({
    query,
    queryConfig,
    children
}: GetAllVentaQueryProps) {
    const queryResult = useGetAllVentasQuery(query, queryConfig);
    return children && children(queryResult);
}